import styled from 'styled-components';
import { CenterRowDiv, RowListItem } from 'styles';

export const GridList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  row-gap: 24px;
`;

export const IconDiv = styled(CenterRowDiv)`
  width: 48px;
  height: 48px;
  border-radius: 16px;
  justify-content: center;
`;

export const MonitorItem = styled(RowListItem)`
  width: 50%;

  ${({ $line, theme }) => $line && `border-right:1px solid ${theme.colors.gray100}`};
`;
